import { observer } from "mobx-react-lite";
import React from "react";
import uuid from "react-native-uuid";
import type BusinessModuleModel from "../../business/modules/BusinessModuleModel";
import type {
  BusinessModuleModelData,
  Snapshot,
} from "../../business/modules/BusinessModuleModel";
import type { BusinessPlanModel } from "../../business/plan/BusinessPlanModel";
import type BaseModuleDataModel from "../../modules/core/BaseModuleDataModel";
import type { BaseModuleModelData } from "../../modules/core/BaseModuleDataModel";
import type BaseModuleModel from "../../modules/core/BaseModuleModel";
import type { ModuleModelData } from "../../modules/core/BaseModuleModel";
import { Permission } from "../../permissions/types";
import { EditorForm } from "../YooptaEditor";

export const useBusinessStorageSuffix = (businessPlan: BusinessPlanModel) => {
  return React.useCallback(() => {
    return `${businessPlan.uid}/${uuid.v4()}`;
  }, [businessPlan.uid]);
};

export const ModuleEditor: React.FC<{
  module:
    | BaseModuleModel<Snapshot, ModuleModelData<Snapshot>>
    | BaseModuleDataModel<BaseModuleModelData>;
}> = observer(({ module }) => {
  return (
    <EditorForm
      id={`${module.uid}-module-editor`}
      value={module.data.descriptionYooptaEditor}
      onSave={(value) => {
        module.setDescriptionEditor(value ?? null);
      }}
    />
  );
});

export const BusinessModuleEditor: React.FC<{
  businessModule: BusinessModuleModel<
    Snapshot,
    BusinessModuleModelData<Snapshot>
  >;
  fallbackText?: string;
  hideEdit?: boolean;
  maxHeight?: number;
}> = observer((props) => {
  const canEdit =
    !props.hideEdit &&
    props.businessModule.businessPlan.checkPermission(
      Permission.CanEditModules,
    );

  return (
    <EditorForm
      id={`${props.businessModule.uid}-business-editor`}
      value={props.businessModule.data.descriptionYooptaEditor}
      canEdit={canEdit}
      onSave={(value) =>
        props.businessModule.setDescriptionEditor(value ?? null)
      }
      getStoragePathSuffix={useBusinessStorageSuffix(
        props.businessModule.businessPlan,
      )}
    />
  );
});
